module.exports = __webpack_public_path__ + "static/media/no_search_results.d5bb1831.png";